/* eslint-disable camelcase */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'hooks/store-hooks';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { setActiveTab, setConversationHistory, setConversationSummary, setDisplayRecommendedOptions, setIsClarificationCurrentlyActive, toggleInsightsAgentsError } from 'store/slice/conversationSlice';
import { IconButton, Modal, TextField, Tooltip } from '@mui/material';
import client from "client";
import { ENDPOINTS } from "constants/constant";
import { setActiveChatDetails, setActiveChatId, setOutletLoading, setPromptInput, setUserChatDetails } from "store/slice/userSlice";
import { getUserConversationSummaryResponse, updateUserConfigResponse } from "constants/common";
import { HomeIcon, HomeIconActive, ThreadsIcon, ThreadsIconActive, InsightsIcon, InsightsIconActive, GalleryIcon, GalleryIconActive, NotificationIcon, GlossaryIcon, TigerIcon, DomainSelectionDownArrow, InsightshubIcon, InsightshubIconActive, DashboardNewActiveIcon, DashboardNewIcon, UsersIcon, UsersIconActive } from 'assets/images/icons';
import NotificationDrawer from './notificationDrawer';
import AccountMenu from './AccountMenu';

// const domains = [
//   { id:'supply_chain_management',value: "Supply Chain Management", description: "Streamline good and resources" },
//   { id:'cost_management',value: "Cost Management", description: "Control and optimize spend" },
//   { id:'manufacturing',value: "Manufacturing", description: "Efficient, quality production" },
//   { id:'credit',value: "Credit", description: "Manage credit and risk" },
// ];

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { activeTab } = useAppSelector((state) => state.conversation);
  const { selectedDomain, user_id, outletLoading, userType } = useAppSelector((s) => s.user);
  const [notifOpen, setNotifOpen] = useState(false);
  const formattedDomain = selectedDomain
    .replace(/_/g, ' ')
    .split(" ")
    .map(word => {
      if (word.length <= 3) return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
  const [localDomainName, setLocalDomainName] = useState(formattedDomain)
  const [localFormattedDomainName, setLocalFormattedDomainName] = useState(formattedDomain)
  const [domainList, setDomainList] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDomainDialog, setOpenDomainDialog] = useState(false); // State to handle Domain confirmation dialog
  const dropdownRef = useRef<HTMLDivElement>(null);

  const getDataFromAPI: any = async () => {
    try {
      const response = await client.post(ENDPOINTS.domainNames, { username: user_id });
      const resValue = response.data;
      return resValue;
    } catch (error) {
      // console.error("Error fetching data :", error);
      return null;
    }
  };

  useEffect(() => {
    getDataFromAPI().then((data: any) => {
      console.log("Domain List Data:", data);
      if (data.length > 0) {
        setDomainList(data);
      }
    })
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpenDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleDomainClose = () => {
    setOpenDomainDialog(false);
    setLocalDomainName(selectedDomain);
  }

  const displayDomain = (domainId: string) => {
    const domain: any = domainList.find((d: any) => d.id === domainId);
    return domain ? domain.value : formattedDomain;
  }

  const handleConfirmDomain = async () => {
    if (localDomainName === selectedDomain) {
      setOpenDropdown(false);
      setOpenDomainDialog(false);
      return;
    }


    // Close the confirmation UI first so loaders/messages are not shown behind the modal.
    setOpenDropdown(false);
    setOpenDomainDialog(false);

    try {

      const payload: any = {
        username: user_id,
        domain_name: localDomainName,
        call_ipro: JSON.parse(localStorage.getItem('call_ipro') || 'false'),
        call_conversation: JSON.parse(localStorage.getItem('convMode') || 'false'),
        call_kb: JSON.parse(localStorage.getItem('kbMode') || 'false'),
        call_rag: JSON.parse(localStorage.getItem('ragMode') || 'false'),
        call_web_search: JSON.parse(localStorage.getItem('webSearchMode') || 'false'),
        theme: JSON.parse(localStorage.getItem('theme') || 'light'),
        language: JSON.parse(localStorage.getItem('language') || 'english'),
        update_config: true,
      }
      dispatch(setOutletLoading(true));
      const response = await updateUserConfigResponse(payload);
      dispatch(setUserChatDetails(response.data));

      const conversationSummaryPayload: any = {
        username: user_id,
        domain_name: localDomainName
      }
      const summaryResponse = await getUserConversationSummaryResponse(conversationSummaryPayload);
      if (summaryResponse?.data) {
        const updatedSummary = summaryResponse.data;
        dispatch(setConversationSummary(updatedSummary))
      } else {
        dispatch(setConversationSummary([]))
      }

      if (location.pathname.includes('/chat') || location.pathname.includes('/threads')) {
        dispatch(setActiveChatId('new'))
        navigate("/threads/new");
        dispatch(setIsClarificationCurrentlyActive(false))
        dispatch(setDisplayRecommendedOptions(false));
        dispatch(setConversationHistory([]));
        dispatch(setActiveChatDetails({}))
        dispatch(toggleInsightsAgentsError(false));
        dispatch(setPromptInput(""));
      }
      dispatch(setOutletLoading(false));

    } catch (error) {
      console.error("Error updating domain:", error);
    }



  }

  const navItems = [
    // { label: 'Home', route: '/welcome', icon: HomeIcon, iconActive: HomeIconActive },
    { label: 'Feeds', route: '/insightshub', icon: InsightshubIcon, iconActive: InsightshubIconActive },
    { label: 'Threads', route: '/threads', icon: ThreadsIcon, iconActive: ThreadsIconActive },
    // { label: 'Insights', route: '/insights', icon: InsightsIcon, iconActive: InsightsIconActive },
    // { label: 'Gallery', route: '/gallery', icon: GalleryIcon, iconActive: GalleryIconActive },

    // Commented out admin Users nav item as requested
    // ...(userType === 'admin'
    //   ? [{
    //     label: 'Users',
    //     route: '/users',
    //     icon: UsersIcon,
    //     iconActive: UsersIconActive
    //   }]
    //   : [])
  ];

  useEffect(() => {
    // support both BrowserRouter and HashRouter (e.g. location.hash = "#/threads/new")
    const currentPath = location.hash ? location.hash.replace(/^#/, '') : location.pathname;
    const match = navItems.find((item) => currentPath.includes(item.route));
    if (match) dispatch(setActiveTab(match.label));
    const matchDashboard = currentPath.includes('/dashboard');
    if (matchDashboard) {
      dispatch(setActiveTab('Dashboard'));
    }
  }, [location.pathname, location.hash]);

  return (
    <header className="h-[64px] w-full flex items-center px-6 bg-white dark:bg-[#212121] shadow-md dark:shadow-lg relative z-50">
      {/* Left Section */}
      <div className="flex items-center gap-3">
        <TigerIcon className="w-5 h-5 cursor-pointer" />
        <span className="text-[#F7901D]">|</span>
        <div className="text-[16px] font-bold cursor-pointer" onClick={() => navigate('/')}>
          Insights Pro
        </div>
      </div>

      {/* Center Navigation Tabs */}
      <div className="absolute left-1/2 transform -translate-x-1/2 h-full flex gap-10 items-center">
        {navItems.map((item: any) => {
          const isActive = activeTab === item.label;
          const IconComponent = isActive ? item.iconActive : item.icon;
          return (
            <div
              key={item.label}
              className={`flex flex-col items-center justify-center cursor-pointer relative h-full
                  ${outletLoading || isActive ? "pointer-events-none" : ""} ${outletLoading ? "opacity-40" : ""}  `}
              onClick={() => {
                if (outletLoading) return;
                if (isActive) return;
                navigate(item.route);
                dispatch(setActiveTab(item.label));
              }}
            >
              <IconComponent className="w-5 h-5" />
              <span
                className={`text-[12px] transition-colors duration-200 ${isActive
                  ? 'text-[#F7901D] font-bold dark:text-[#F7901D]'
                  : 'text-[#000000] dark:text-gray-300'
                  }`}
              >
                {item.label}
              </span>
              {isActive && (
                <div className="absolute bottom-[0px] w-[48px] h-[2.5px] bg-[#F7901D] dark:bg-[#F7901D]" />
              )}
            </div>
          );
        })}
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-4 ml-auto text-lg text-gray-600 dark:text-gray-300">
        {/* Domain dropdown */}
        {activeTab !== 'Dashboard' &&
          <div className="relative" ref={dropdownRef}>
            <button
              type="button"
              onClick={() => setOpenDropdown((prev) => !prev)}
              className="flex items-center justify-between px-2 py-1 text-[12px] border text-[#FFFFFF] rounded-[6px] cursor-pointer bg-[#f7901d] w-[150px] h-[27px] overflow-hidden text-ellipsis whitespace-nowrap"
            >
              <span className="truncate text-[12px] font-bold">{displayDomain(selectedDomain)}</span>
              <DomainSelectionDownArrow className="w-3 h-3 ml-2" />
            </button>

            {openDropdown && (
              <div className="absolute top-full left-0 mt-2 bg-white dark:bg-gray-800 shadow-lg rounded-md z-50">
                <h4 className="text-[10px] px-3 pt-3 font-semibold text-[#707070] mb-2">
                  DOMAIN SPACE
                </h4>
                <div className="flex flex-col gap-2 max-h-[200px] h-fit overflow-y-auto">
                  {domainList.map((d: any) => {
                    const isSelected = d.id === selectedDomain;
                    const inputId = `domain-${d.value}`;
                    return (
                      <div key={d.id}>
                        <div
                          className={`flex items-start gap-2 min-w-[210px] cursor-pointer px-3 py-1 ${!isSelected ? 'hover:bg-[#FCE3C7]' : ''
                            }`}
                          style={{ minWidth: 'max-content' }}
                        >
                          {/* Custom radio */}
                          <input
                            id={inputId}
                            type="radio"
                            name="domain"
                            value={d.value}
                            checked={isSelected}
                            onChange={() => {
                              if (d.id === selectedDomain) {
                                setOpenDropdown(false);
                                return;
                              }
                              setOpenDomainDialog(true);
                              setLocalDomainName(d.id);
                              setLocalFormattedDomainName(d.value);
                            }}
                            className="appearance-none w-[5.16px] h-[5.16px] border border-[#f7901d] rounded-full checked:bg-[#f7901d] checked:border-[#f7901d] cursor-pointer mt-[5.42px] ml-[2.42px]"
                          />
                          <label
                            htmlFor={inputId}
                            className="flex flex-col text-[12px] cursor-pointer"
                          >
                            <span
                              className={`${isSelected
                                ? 'text-[#f7901d] font-bold'
                                : 'text-[#312E2D]'
                                }`}
                            >
                              {d.value}
                            </span>
                            <span className="text-[10px] text-[#707070]">
                              {d.description}
                            </span>
                          </label>
                        </div>
                        <div className="border-b-[0.5px] mx-[1rem] border-[#F7F3EF] dark:border-gray-700" />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        }
        {/* <GlossaryIcon className="w-5 h-5 cursor-pointer" /> */}
        {userType === 'admin' &&
          <button
            type="button"
            onClick={() => {
              navigate('/dashboard');
              dispatch(setActiveTab('Dashboard'));
            }}
            aria-label="Open notifications"
            className="cursor-pointer"
          >
            {activeTab === 'Dashboard' ? <DashboardNewActiveIcon className="w-5 h-5" /> : <DashboardNewIcon className="w-5 h-5 grayscale" />}
          </button>
        }
        <button
          type="button"
          onClick={() => setNotifOpen(true)}
          aria-label="Open notifications"
          className="cursor-pointer"
        >
          <NotificationIcon className="w-5 h-5" />
        </button>
        <AccountMenu />
      </div>

      <NotificationDrawer open={notifOpen} onClose={() => setNotifOpen(false)} />
      {/* Domain Change Confirmation Dialog */}
      <Modal open={openDomainDialog}>
        <div
          className="dark:bg-[#212121] bg-white absolute rounded-[10px] top-1/2 left-1/2 transform -translate-x-2/4 -translate-y-2/4 p-5 w-[460px] h-[181px] outline-none"
          data-testid="domain-change-modal"
        >
          <div className="flex font-poppins dark:text-[#ffffff] font-semibold text-[14px] text-black mb-[25px]">
            Domain Change
          </div>
          <div className="fontInsights text-[12px] text-black">
            <p className="dark:text-[#ffffff]">
              Are you sure you want to change your domain from {formattedDomain} to {localFormattedDomainName}?
            </p>
          </div>
          <div className="flex justify-end gap-5 mt-[30px] font-medium">
            <button
              type="button"
              className=" text-[12px]  text-[#8D8D8D] h-[27px] w-[69px]"
              onClick={handleDomainClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="rounded-3xl text-[12px]  dark:bg-[#cf8600] bg-[#F7901D] text-[white] h-[28px] w-[60px]"
              onClick={handleConfirmDomain}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </header>


  );
};

export default Header;
